export const openExternal = async (url) => {
    window.location.assign(url);
};

export const openContact = async (url) => {
    window.location.assign(url);
};

export const onIncomingLink = () => () => {};
